<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目招标文件审核会签表</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <el-form-item label="需求类型">
            <el-radio-group v-model="form.type" class="type-radio-type">
              <el-radio-button label="0">集团审批</el-radio-button>
              <el-radio-button label="1">子公司内部审批</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <create-invite-approval
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          >
          </create-invite-approval>

          <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :arr="attachmentArr"
                :type="10"
              ></attachments>
            </el-form-item>
          </div>

          <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
          <div class="clear label-mx">
            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item
              ref="approval"
              :approvalUsers="approvalUsersData"
              :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"
            ></approval-item>
          </div>

          <div class="tip tip-table">
            <p>
              <span class="tip-lable">注：</span
              >1、招标限额以上的采购或工程需招标文件会签，工程及工程相关配套采购需工程技术中心审核。
            </p>
            <p>
              2、500万元（含）以上采购或工程施工、100万元以上工程类服务需集团公司总经理办公会议审议、招标领导小组（总经理）签批。
            </p>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="createProject()"
                class="form-btn"
                type="success"
                >确认提交项目招标文件审批
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "@/components/ApprovalItem";
import CreateInviteApproval from "@/page/form/createInviteApproval";

import ObjectUtil from "../mixins/objectUtil";
export default {
  components: {
    ApprovalItem,
    CreateInviteApproval,
    Attachments,
  },
  mixins: [approvalUsers, ObjectUtil],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      tableData: [],

      project: {},
      form: {
        projectId: "",
        dldw: "",
        content: "",
        mode: "",

        // 是否线下审批通过
        underLine: "",

        type: 0,
      },
      approvalUsersData: [],

      // 附件
      attachmentArr: [],
      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
    };
  },
  created() {
    this.getApplyData();
    // this.setSelectArr(this.applyInfo, 10)
  },
  mounted() {
    this.form.projectId = this.$route.params.projectId;
    this.getProject();
    this.approvalUsersData = this.approvalUsers["c10_" + this.form.type];
  },
  methods: {
    // 获取审批表原内容
    getApplyData() {
      this.form.signId = this.$route.params.applyId;
      if (this.form.signId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
      } else {
        this.setSelectArr(this.applyInfo, 10, this.form.type / 1);
      }
    },
    // 获取原审批表内容
    getProjectApplyInfo() {
      ajax.get("/gc/project/invitesign/info/" + this.form.signId, "", (res) => {
        this.applyInfo = res.vo;

        this.form.dldw = this.applyInfo.dldw;
        this.form.content = this.applyInfo.content;
        this.form.mode = this.applyInfo.mode;
        this.form.type = this.applyInfo.type;

        // 是否线下通过审批
        this.form.underLine = this.applyInfo.underLine.toString();

        this.attachmentArr = this.applyInfo.attachments
          ? this.applyInfo.attachments
          : [];

        this.setSelectArr(this.applyInfo, 10, this.form.type / 1);
        this.formLoading = false;
      });
    },
    // 获取项目详情
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);
      });
    },
    // 提交项目招标文件
    createProject() {
      this.form = this.$refs.create.getFromData();
      if (this.form.underLine == "") {
        this.$message.error("请标注本次审批是否已线下通过");
        return;
      }

      // 赋值合同ID
      this.form.contractId = this.project.contractId;

      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();

      console.log(this.form.approvalUserIds);
      this.form.attachments = this.$refs.attachments.getAttachments();

      this.formLoading = true;
      let _url = !this.form.signId
        ? "/gc/project/invitesign"
        : "/gc/project/invitesign/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.$message.success("项目招标文件审批提交成功，请耐心等待领导审批");
          this.$router.back();
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {
    "form.type"() {
      this.approvalUsersData = this.approvalUsers["c10_" + this.form.type];
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createInviteApproval.vue